import {
  Avatar,
  Box,
  Divider,
  IconButton,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
  Stack,
  Typography,
} from "@mui/material";
import TopHeadingDividerComponent from "../AccountSetting/TopHeadingDividerComponent";
import GroupsIcon from "../../UI/GroupsIcon";
import CreateIcon from "../../UI/CreateIcon";
import EventsIcon from "../../UI/EventsIcon";
import PagesIcon from "../../UI/PagesIcon";
import SaveChangingsButton from "../AccountSetting/SaveChangingsButton";
import CommunityMenuIcon from "../../UI/CommunityMenuIcon";
const communityData = [
  { icon: GroupsIcon, title: "Groups" },
  { icon: EventsIcon, title: "Events" },
  { icon: PagesIcon, title: "Pages" },
];

const upcomingEventsData = [
  {
    listIcon: "/icons/giftIcon.svg",
    title: "Friend's Birthday",
    date: "Jun 25, 2028",
  },
  {
    listIcon: "/icons/moonIcon.svg",
    title: "Holiday",
    date: "Jun 28, 2028",
  },
  {
    listIcon: "/icons/groupIcon.svg",
    title: "Group Meetup",
    date: "Aug 19, 2028",
  },
  {
    listIcon: "/icons/educationIcon.svg",
    title: "Graduation",
    date: "Dec 22, 2028",
  },
];
const groupsYouHaveJoinedData = [
  {
    title: "WhatsApp Updates - Rumors",
    date: "Last active about an hour ago",
  },
  {
    title: "International Students - Australia",
    date: "Last active 5 hours ago",
  },
];
const pagesYouHaveJoinedData = [
  {
    title: "24/7 Consultancy",
    date: "Last active about an hour ago",
  },
  {
    title: "Logic Aspire",
    date: "Last active 5 hours ago",
  },
];
function CommunityInnerSection() {
  return (
    <Stack sx={{ gap: "16px" }}>
      <Stack
        id="community-inner"
        sx={{
          bgcolor: "#ffffff",
          borderRadius: "22px",
          p: "20px",
        }}
      >
        <TopHeadingDividerComponent
          primary="Community"
          secondary="Based on your profile, preferences, and activity like applies, searches, and saves"
          divider={false}
          primaryBottomPadding="4px"
          secondaryBottomPadding="0px"
        />
        <Divider
          sx={{
            height: "1px",
            bgcolor: "#EBEBEB",
            border: "none",
            my: "18px",
            mx: "-20px",
          }}
        />
        <Stack direction="row" sx={{ alignItems: "start", gap: "18px" }}>
          {" "}
          {communityData.map((community) => (
            <Stack
              sx={{
                border: "1px solid #E3E3E3",
                borderRadius: "24px",
                p: "20px",
                minWidth: "180px",
              }}
            >
              <community.icon />
              <Typography
                variant="body2"
                sx={{
                  fontSize: "15px",
                  fontWeight: "400",
                  lineHeight: "100%",
                  fontFamily: "Inter",
                  py: "12px",
                }}
              >
                {community.title}
              </Typography>{" "}
              <Box
                component="button"
                sx={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                  p: "0px",
                  cursor: "pointer",
                  border: "none",
                  bgcolor: "transparent",
                  gap: "10px",
                  pt: "20px",
                }}
              >
                <CreateIcon />

                <Typography
                  variant="body2"
                  sx={{
                    fontSize: "15px",
                    fontWeight: "400",
                    lineHeight: "100%",
                    fontFamily: "Inter",
                  }}
                >
                  Create
                </Typography>
              </Box>
            </Stack>
          ))}
        </Stack>
      </Stack>
      <Stack
        id="current-events"
        sx={{
          bgcolor: "#ffffff",
          borderRadius: "22px",
          p: "20px",
        }}
      >
        <TopHeadingDividerComponent
          primary="Current Events"
          secondary="Based on your profile, preferences, and activity like applies, searches, and saves"
          divider={false}
          primaryBottomPadding="4px"
          secondaryBottomPadding="0px"
        />
        <Box>
          {upcomingEventsData.map((event) => (
            <List sx={{ py: "0px" }}>
              <Divider
                sx={{
                  my: "14px",
                  height: "1px",
                  bgcolor: "#EBEBEB",
                  border: "none",
                  mx: "-20px",
                }}
              />
              <ListItem sx={{ p: "0px" }}>
                <ListItemAvatar>
                  <Avatar
                    sx={{
                      width: 50,
                      height: 50,
                      objectFit: "cover",
                      bgcolor: "#EBEBEB",
                    }}
                  >
                    <Box component="img" src="/icons/giftIcon.svg"></Box>
                  </Avatar>
                </ListItemAvatar>
                <ListItemText
                  primary={event.title}
                  secondary={event.date}
                  sx={{
                    "& .MuiTypography-root": { pl: "4px" }, // Remove text padding
                    "& .MuiTypography-body1": {
                      color: "#000000",
                      pb: "2px",
                      fontSize: "16px",
                      lineHeight: "20px",
                      fontWeight: "600",
                    }, // Primary text
                    "& .MuiTypography-body2": {
                      color: "#475569",
                      fontWeight: "400",
                      fontSize: "15px",
                    }, // Secondary text
                  }}
                />
                {/* <IconButton edge="end">
                  <Box component="img" src="/icons/bellIcon.svg"></Box>
                </IconButton> */}
              </ListItem>
            </List>
          ))}
        </Box>
      </Stack>
      <Stack
        id="Groups-you-ve-joined"
        sx={{
          bgcolor: "#ffffff",
          borderRadius: "22px",
          p: "20px",
        }}
      >
        {" "}
        <TopHeadingDividerComponent
          primary="Groups you've joined"
          secondary="Based on your profile, preferences, and activity like applies, searches, and saves"
          divider={false}
          primaryBottomPadding="4px"
          secondaryBottomPadding="0px"
        />
        <Box>
          {groupsYouHaveJoinedData.map((event) => (
            <List sx={{ py: "0px" }}>
              <Divider
                sx={{
                  my: "14px",
                  height: "1px",
                  bgcolor: "#EBEBEB",
                  border: "none",
                  mx: "-20px",
                }}
              />
              <ListItem sx={{ p: "0px" }}>
                <ListItemAvatar>
                  <Avatar
                    sx={{
                      width: 50,
                      height: 50,
                      objectFit: "cover",
                      bgcolor: "#EBEBEB",
                      color: "#ebebeb",
                    }}
                  ></Avatar>
                </ListItemAvatar>
                <ListItemText
                  primary={event.title}
                  secondary={event.date}
                  sx={{
                    "& .MuiTypography-root": { pl: "4px" }, // Remove text padding
                    "& .MuiTypography-body1": {
                      color: "#000000",
                      pb: "2px",
                      fontSize: "16px",
                      lineHeight: "20px",
                      fontWeight: "600",
                    }, // Primary text
                    "& .MuiTypography-body2": {
                      color: "#475569",
                      fontWeight: "400",
                      fontSize: "15px",
                    }, // Secondary text
                  }}
                />

                <Box
                  edge="end"
                  sx={{
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "center",
                    gap: "10px",
                  }}
                >
                  <SaveChangingsButton mt="0px">View Group</SaveChangingsButton>
                  <Box
                    component="button"
                    sx={{
                      cursor: "pointer",
                      border: "none",
                      bgcolor: "transparent",
                      p: "0px",
                      height: "35px",
                    }}
                  >
                    {" "}
                    <CommunityMenuIcon />
                  </Box>
                </Box>
              </ListItem>
            </List>
          ))}
        </Box>
      </Stack>
      <Stack
        id="Pages-you-ve-joined"
        sx={{
          bgcolor: "#ffffff",
          borderRadius: "22px",
          p: "20px",
        }}
      >
        {" "}
        <TopHeadingDividerComponent
          primary="Pages you've joined"
          secondary="Based on your profile, preferences, and activity like applies, searches, and saves"
          divider={false}
          primaryBottomPadding="4px"
          secondaryBottomPadding="0px"
        />
        <Box>
          {pagesYouHaveJoinedData.map((event) => (
            <List sx={{ py: "0px" }}>
              <Divider
                sx={{
                  my: "14px",
                  height: "1px",
                  bgcolor: "#EBEBEB",
                  border: "none",
                  mx: "-20px",
                }}
              />
              <ListItem sx={{ p: "0px" }}>
                <ListItemAvatar>
                  <Avatar
                    sx={{
                      width: 50,
                      height: 50,
                      objectFit: "cover",
                      bgcolor: "#EBEBEB",
                      color: "#ebebeb",
                    }}
                  ></Avatar>
                </ListItemAvatar>
                <ListItemText
                  primary={event.title}
                  secondary={event.date}
                  sx={{
                    "& .MuiTypography-root": { pl: "4px" }, // Remove text padding
                    "& .MuiTypography-body1": {
                      color: "#000000",
                      pb: "2px",
                      fontSize: "16px",
                      lineHeight: "20px",
                      fontWeight: "600",
                    }, // Primary text
                    "& .MuiTypography-body2": {
                      color: "#475569",
                      fontWeight: "400",
                      fontSize: "15px",
                    }, // Secondary text
                  }}
                />

                <Box
                  edge="end"
                  sx={{
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "center",
                    gap: "10px",
                  }}
                >
                  <SaveChangingsButton mt="0px">View Group</SaveChangingsButton>
                  <Box
                    component="button"
                    sx={{
                      cursor: "pointer",
                      border: "none",
                      bgcolor: "transparent",
                      p: "0px",
                      height: "35px",
                    }}
                  >
                    {" "}
                    <CommunityMenuIcon />
                  </Box>
                </Box>
              </ListItem>
            </List>
          ))}
        </Box>
      </Stack>
    </Stack>
  );
}

export default CommunityInnerSection;
